import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, Moon, Sun, Search, LogOut, Command } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { CommandDialog, CommandInput, CommandList, CommandGroup, CommandItem, CommandEmpty } from "@/components/ui/command";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export default function Header({ onMenu }) {
  const { dark, setDark, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [res, setRes] = useState({ leads: [], campaigns: [] });
  const nav = useNavigate();

  useEffect(() => {
    const h = (e) => { if ((e.metaKey || e.ctrlKey) && e.key === "k") { e.preventDefault(); setOpen(true); } };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, []);

  useEffect(() => {
    if (q.length < 2) return;
    const t = setTimeout(() => api.get(`/search?q=${encodeURIComponent(q)}`).then((r) => setRes(r.data)).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <header className="h-16 border-b bg-card flex items-center gap-3 px-4 lg:px-6 sticky top-0 z-20">
      <button className="lg:hidden" onClick={onMenu} data-testid="menu-btn"><Menu className="w-5 h-5" /></button>
      <button onClick={() => setOpen(true)} data-testid="global-search-btn" className="flex items-center gap-2 text-sm text-slate-400 border rounded-lg px-3 py-2 hover:bg-accent w-full max-w-xs">
        <Search className="w-4 h-4" /> Search leads, campaigns...
        <span className="ml-auto hidden sm:flex items-center gap-0.5 text-[10px]"><Command className="w-3 h-3" />K</span>
      </button>
      <div className="ml-auto flex items-center gap-2">
        <Button variant="ghost" size="icon" onClick={() => setDark(!dark)} data-testid="theme-toggle">
          {dark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
        </Button>
        <Button variant="ghost" size="icon" onClick={logout} data-testid="logout-btn"><LogOut className="w-4 h-4" /></Button>
      </div>

      <CommandDialog open={open} onOpenChange={setOpen}>
        <CommandInput placeholder="Search leads & campaigns..." value={q} onValueChange={setQ} />
        <CommandList>
          <CommandEmpty>No results.</CommandEmpty>
          {res.leads.length > 0 && (
            <CommandGroup heading="Leads">
              {res.leads.map((l) => (
                <CommandItem key={l.id} onSelect={() => { setOpen(false); nav(`/leads?lead=${l.id}`); }}>{l.name} · {l.mobile}</CommandItem>
              ))}
            </CommandGroup>
          )}
          {res.campaigns.length > 0 && (
            <CommandGroup heading="Campaigns">
              {res.campaigns.map((c) => (
                <CommandItem key={c.id} onSelect={() => { setOpen(false); nav(`/campaigns`); }}>{c.name}</CommandItem>
              ))}
            </CommandGroup>
          )}
        </CommandList>
      </CommandDialog>
    </header>
  );
}
